module.exports = __webpack_public_path__ + "img/WebexToken_1.82ab844f.png";